import type { RudderAnalytics } from '@metrics/types';

declare global {
  interface Window {
    rudderanalytics: RudderAnalytics;
  }
}

/**
 * Function to get the Rudder Analytics instance from `window` object.
 */
export function getRudderAnalytics(): RudderAnalytics | void {
  return typeof window !== 'undefined' && window.rudderanalytics;
}
